import axios from "@/lib/axios";
import { useQuery } from "@tanstack/vue-query";
import type { TaxSystem } from "@/interfaces/taxSystem";

const getTaxSystems = async () => {
  const { data } = await axios.get<TaxSystem[]>(`/api/taxsystem`);
  return data;
};

const useCompanyGroups = () => {
  const { data, isLoading, isError, refetch } = useQuery(["taxsystems"], () =>
    getTaxSystems()
  );

  return {
    data,
    isError,
    isLoading,
    refetch,
  };
};

export default useCompanyGroups;
